// Estados de reembolso por `sequenceOrder` (tabla refunds-requests-changelog-status).
// Se identifican siempre por código: los nombres se pueden editar en la BD.
export const REFUND_STATUS = Object.freeze({
  REGISTERED: 0,
  IN_REVIEW: 100,
  TO_FIX: 200,
  REJECTED: 300,
  APPROVED: 400,
  VETOPS_APPROVED: 410,
  AUXILIA_APPROVED: 420,
  PAID: 500,
  INVALID_PAYMENT: 600
});

// Pasos intermedios del flujo Auxilia (BCI/LiderBCI, Accidente/Urgencia).
export const AUXILIA_STATUSES = Object.freeze([
  REFUND_STATUS.VETOPS_APPROVED,
  REFUND_STATUS.AUXILIA_APPROVED
]);

const MISSING_STEP_HINTS = {
  [REFUND_STATUS.AUXILIA_APPROVED]: 'Requiere Aprobado por VetOps',
  [REFUND_STATUS.APPROVED]: 'Requiere Aprobado por Auxilia'
};

const GENERIC_HINT = 'No disponible en el estado actual';

/**
 * 410/420 solo se muestran si el backend marca el reembolso dentro del flujo
 * Auxilia, o si ya está en uno de esos estados (para no esconder el actual).
 */
export function isStatusVisible(code, { requiresAuxiliaReview, currentStatus } = {}) {
  if (!AUXILIA_STATUSES.includes(code)) return true;
  return requiresAuxiliaReview === true || AUXILIA_STATUSES.includes(currentStatus);
}

/**
 * Motivo por el que una opción no se puede elegir, o null si se puede.
 * La regla vive en el backend (`allowedNextStatuses`); sin esa lista (backend
 * antiguo) no se deshabilita nada. El estado actual nunca se deshabilita: el
 * modal parte en él y guardar sin cambiarlo solo edita el registro.
 */
export function statusDisabledReason(code, { allowedNextStatuses, currentStatus } = {}) {
  if (!Array.isArray(allowedNextStatuses)) return null;
  if (code === currentStatus || allowedNextStatuses.includes(code)) return null;
  return MISSING_STEP_HINTS[code] || GENERIC_HINT;
}
